import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import ThreadList from '../components/forum/thread/ThreadList';
import AddCircleButton from '../components/button/AddCircleButton';
import EmptyMessageForum from '../components/common/EmptyMessageForum';
import SettingContext from '../contexts/settingContext';

import { asyncPopulateUserThreads } from '../middleware/shared/action';
import {
  POPULAR_CATEGORY, POPULAR_CATEGORY_EN, THREAD, THREAD_EN,
} from '../utils/common/constant';
import useInput from '../utils/common/customHook';
import {
  DivCategoryButton, DivCategoryHome, DivHomePageAction, SectionHomePage,
} from '../components/styled';

const HomePage = () => {
  const {
    threads = [],
    users = [],
  } = useSelector((states) => states);
  const dispatch = useDispatch();
  const { locale } = React.useContext(SettingContext);

  const [categories, onCategoryChange] = useInput('');
  const [selectedCategory, setSelectedCategory] = useInput('');

  React.useEffect(() => {
    dispatch(asyncPopulateUserThreads());
  }, [dispatch]);

  const handleClick = (event) => {
    event.preventDefault();
    onCategoryChange(event);
    setSelectedCategory(event);
  };

  const categoryThread = threads.map(({ category }) => category);
  const uniqueCategory = [...new Set(categoryThread)];
  const buttonCategoryThread = categories === selectedCategory && uniqueCategory.map((thread) => {
    return (
      <button key={thread} className="button-category-item" type="button" aria-label="category" onClick={handleClick}>{thread}</button>
    );
  });

  const threadList = threads.map((thread) => ({
    ...thread,
    user: users.find((user) => user.id === thread.ownerId),
  }));
  const filteredByCategory = threadList.filter((thread) => thread.category === categories);
  const threadListByCategory = categories === ''
    ? <ThreadList threads={threadList} />
    : <ThreadList threads={filteredByCategory} />;

  return (
    <SectionHomePage>
      <DivCategoryHome>
        <h3>{locale === 'id' ? POPULAR_CATEGORY : POPULAR_CATEGORY_EN}</h3>
        <DivCategoryButton className="container-button-category">{buttonCategoryThread}</DivCategoryButton>
      </DivCategoryHome>
      <h2>{locale === 'id' ? THREAD : THREAD_EN}</h2>
      {
        Array.isArray(threadList) && threadList.length !== 0
          ? threadListByCategory
          : <EmptyMessageForum archived={false} />
      }
      <DivHomePageAction>
        <AddCircleButton />
      </DivHomePageAction>
    </SectionHomePage>
  );
};

export default HomePage;
